/*eslint-disable*/
import { styled, Box } from '@mui/material';

export const TableRoot = styled(Box)(({ theme }) => ({
  width: '100%;',
  marginTop: '10px',
  marginBottom: '10px',
}));
